// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__w7rk0"};